<template>
  <LoadingState v-if="isLoading()" :size="50" />
  <ErrorState v-else-if="isErrored()" />
  <div v-else-if="newRelic">
    <CardActionContent :title="$t('global.new-relic')" :buttons="getButtons()">
      <template #description>
        <LoadingState v-if="isUpdating" :size="50" />
        <p v-else>{{ getMessage() }}</p>
      </template>
    </CardActionContent>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import SiteDisableNewRelic from "@/components/smart/modals/SiteDisableNewRelic";
import SiteEnableNewRelic from "@/components/smart/modals/SiteEnableNewRelic";
import store from "@/store";

export default {
  name: "NewRelic",
  components: {
    CardActionContent,
    ErrorState,
    LoadingState,
  },
  props: {
    plan: Object,
    site: Object,
  },
  setup(props, { root }) {
    const newRelic = computed(() => store.getters["sites/getNewRelic"]);
    const status = computed(() => store.getters["sites/getNewRelicStatus"]);
    const isUpdating = computed(() => store.getters["sites/isNewRelicUpdating"](props.site.id));

    const isEnabled = () => newRelic.value.enabled;
    const isErrored = () => status.value.isErrored;
    const isLoading = () => status.value.isLoading;

    const getButtons = () => {
      if (!(status.value.isLoaded || status.value.isUpdating)) return null;
      if (isEnabled()) {
        return [
          new NavLink(
            root.$t("global.disable"),
            null,
            openDisableForm,
            false,
            "primary",
            null,
            isUpdating.value || props.disabled
          ),
        ];
      } else {
        return [
          new NavLink(
            root.$t("global.enable"),
            null,
            openEnableForm,
            false,
            "primary",
            null,
            isUpdating.value || props.disabled
          ),
        ];
      }
    };

    const getMessage = () =>
      root.$t(`global.${isEnabled() ? "new-relic-enabled-message" : "new-relic-disabled-message"}`);

    const openDisableForm = () =>
      store.dispatch("modals/open", {
        template: SiteDisableNewRelic,
        data: { plan: props.plan, site: props.site },
      });
    const openEnableForm = () =>
      store.dispatch("modals/open", {
        template: SiteEnableNewRelic,
        data: { plan: props.plan, site: props.site },
      });

    onMounted(() => {
      store.dispatch("sites/getNewRelic", props.site.id);
    });

    return {
      getButtons,
      getMessage,
      isEnabled,
      isErrored,
      isLoading,
      isUpdating,
      newRelic,
      status,
    };
  },
};
</script>
